import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import axios from "axios";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { Button, Grid } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import MenuItem from "@material-ui/core/MenuItem";
import ReactDOM from "react-dom";
import config from "../../config";
import canawhoLogoImgNotFound from "../../assets/img/logo-black-img-not-found.png";
import ImageUpload from "../image-upload.component";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";

const BACKEND_URL = config.backend.host;

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing(),
    minWidth: 120,
  },
  textField: {
    marginLeft: 10,
    marginRight: 10,
    width: "250px",
  },
  dense: {
    marginTop: 16,
  },
  menu: {
    width: 200,
  },
  button: {
    margin: theme.spacing(),
  },
  leftIcon: {
    marginRight: theme.spacing(),
    fontSize: 20,
  },
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
});

class AdvertisementAdd extends Component {
  state = {
    image: "",
    link: "",
    linked_brand: "",
    brands: [],
    type: "",
    typeList: ["Banner", "Featured"],
    title: "Add",
    isEdit: false,
    labelWidth: 0, //used to fix select's border,
    checked: [],
    positions: [],
  };
  constructor(props) {
    super(props);
    this.btnSaveOnClick = this.btnSaveOnClick.bind(this);
    this.btnCancelOnClick = this.btnCancelOnClick.bind(this);
    //TODO: use the json from the previously call, if possible
    if (props.match.params.id) {
      axios
        .get(BACKEND_URL + "/advertisement/" + props.match.params.id)
        .then((response) => {
          // console.log(response);
          this.loadData(response.data);
          axios
            .get(BACKEND_URL + "/advertisement/positions")
            .then((res) => {
              this.setState({
                positions: res.data.positions,
                checked: response.data.positions,
              });
            })
            .catch((err) => {
              // console.log(err);
              // console.log(err.response);
            });
        })
        .catch((err) => {
          //  console.log(err)
        });
    } else {
      axios
        .get(BACKEND_URL + "/advertisement/positions")
        .then((res) => {
          this.setState({ positions: res.data.positions });
        })
        .catch((err) => {
          // console.log(err);
          // console.log(err.response);
        });
    }
  }

  componentDidMount() {
    this.setState({
      labelWidth: ReactDOM.findDOMNode(this.InputLabelRef).offsetWidth, //used to fix select's border
    });
    this.listBrand();
  }

  handleToggle = (value) => {
    const currentIndex = this.state.checked.indexOf(value);
    const newChecked = [...this.state.checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    // console.log(newChecked);
    this.setState({ checked: newChecked });
  };

  loadData(advertisement) {
    this.setState({
      _id: advertisement._id,
      image: advertisement.image,
      link: advertisement.link,
      linked_brand: advertisement.linked_brand,
      type: advertisement.type,
      title: "Edit",
      isEdit: true,
    });
  }

  listBrand() {
    axios
      .get(BACKEND_URL + "/brand/")
      .then((response) =>
        this.setState({ brands: response.data.filter((d) => d.is_registered) })
      )
      .catch((err) => alert(err));
  }

  btnCancelOnClick(e) {
    e.preventDefault();
    this.props.history.goBack();
  }

  btnSaveOnClick(e) {
    e.preventDefault();
    let obj = {
      image: this.state.image,
      link: this.state.link,
      type: this.state.type,
      positions: this.state.checked,
    };

    if (this.state.linked_brand) {
      obj = {
        ...obj,
        linked_brand: this.state.linked_brand,
      };
    }

    //TODO: show message DONE with snackbar
    if (this.state.isEdit) {
      axios
        .put(BACKEND_URL + `/advertisement/${this.state._id}`, obj)
        .then((res) => this.saveSuccess(res))
        .catch((e) =>
          alert(`Error: ${e} | Response: ${e.response.data.message}`)
        );
    } else {
      axios
        .post(BACKEND_URL + "/advertisement", obj)
        .then((res) => this.saveSuccess(res))
        .catch((e) =>
          alert(`Error: ${e} | Response: ${e.response.data.message}`)
        );
    }
  }
  saveSuccess(response) {
    //TODO: Set a snack bar with Redux to show messages after saving
    alert("Saved");
    this.props.history.goBack();
  }

  handleChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };

  cbSetImageNewLink(link) {
    this.setState({ image: link });
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Typography variant="h4" gutterBottom>
          {this.state.title} Advertisement
        </Typography>
        <Grid container>
          <form
            style={{ width: "100%" }}
            autoComplete="off"
            onSubmit={this.btnSaveOnClick}
          >
            <Grid item xs={12}>
              <Grid
                container
                spacing={16}
                //justify='center'
                alignItems="center"
                direction="column"
              >
                <Grid item>
                  <img
                    alt=""
                    src={
                      this.state.image
                        ? this.state.image
                        : canawhoLogoImgNotFound
                    }
                    width="200px"
                  />
                </Grid>
                <Grid item>
                  <ImageUpload cbFunction={this.cbSetImageNewLink.bind(this)}>
                    Upload Image
                  </ImageUpload>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="tfLink"
                label="Link"
                margin="normal"
                variant="outlined"
                style={{ width: "98%", marginLeft: 10 }}
                value={this.state.link}
                onChange={this.handleChange("link")}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel
                  ref={(ref) => {
                    this.InputLabelRef = ref;
                  }}
                  htmlFor="outlined-linked_brand"
                >
                  Linked Brand
                </InputLabel>
                <Select
                  value={this.state.linked_brand}
                  onChange={this.handleChange("linked_brand")}
                  input={
                    <OutlinedInput
                      labelWidth={this.state.labelWidth}
                      name="linked_brand"
                      id="outlined-linked_brand"
                    />
                  }
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {this.state.brands.map((b) => (
                    <MenuItem value={b._id}>{b.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel
                  ref={(ref) => {
                    this.InputLabelRef = ref;
                  }}
                  htmlFor="outlined-type"
                >
                  Type
                </InputLabel>
                <Select
                  value={this.state.type}
                  onChange={this.handleChange("type")}
                  input={
                    <OutlinedInput
                      labelWidth={this.state.labelWidth}
                      name="type"
                      id="outlined-type"
                    />
                  }
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {this.state.typeList.map((t) => (
                    <MenuItem key={t} value={t}>
                      {t}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {this.state.type === "Banner" ? (
              <Grid item xs={12}>
                <Typography variant="h4" gutterBottom>
                  Choose Advertisement Placement
                </Typography>
                <List className={classes.root}>
                  {this.state.positions.map((value, index) => {
                    const labelId = `checkbox-list-label-${value}`;
                    return (
                      <ListItem
                        key={index}
                        role={undefined}
                        dense
                        button
                        onClick={() => this.handleToggle(value)}
                      >
                        <ListItemIcon>
                          <Checkbox
                            edge="start"
                            checked={this.state.checked.indexOf(value) !== -1}
                            tabIndex={-1}
                            disableRipple
                            inputProps={{ "aria-labelledby": labelId }}
                          />
                        </ListItemIcon>
                        <ListItemText id={labelId} primary={`${value}`} />
                      </ListItem>
                    );
                  })}
                </List>
              </Grid>
            ) : null}
            <Grid item xs={12}>
              <Button
                variant="contained"
                size="medium"
                className={classes.button}
                name="btnSave"
                type="submit"
              >
                <SaveIcon className={classes.leftIcon} />
                Save
              </Button>
              <Button
                variant="contained"
                size="medium"
                className={classes.button}
                onClick={this.btnCancelOnClick}
              >
                <CancelIcon className={classes.leftIcon} />
                Cancel
              </Button>
            </Grid>
          </form>
        </Grid>
      </div>
    );
  }
}

AdvertisementAdd.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdvertisementAdd);
